import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Courses', path: '/courses' },
    { name: 'Schedule', path: '#', disabled: true },
    { name: 'Vibe', path: '/vibe' },
    { name: 'About Us', path: '/about' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#1a1c1b]/95 backdrop-blur-md border-b border-[#3f4816]">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_fight-evolution-2/artifacts/yp7kukjz_Untitled%20design.png" 
                alt="NexGen MMA Logo" 
                className="h-16 w-16 object-contain rounded-full transition-transform group-hover:scale-110"
                style={{ mixBlendMode: 'lighten' }}
              />
            </div>
            <div className="text-[#d9fb06] font-black text-2xl uppercase tracking-tight leading-tight">
              NexGen MMA
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              link.disabled ? (
                <span
                  key={link.path}
                  className="nav-link text-base font-medium text-[#888680] cursor-not-allowed opacity-50"
                >
                  {link.name}
                </span>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`nav-link text-base font-medium transition-colors ${
                    isActive(link.path) ? 'text-[#d9fb06]' : 'text-[#dfddd6] hover:text-[#d9fb06]'
                  }`}
                >
                  {link.name}
                </Link>
              )
            ))}
            <Link
              to="/book"
              className="btn-primary bg-[#d9fb06] text-[#1a1c1b] px-6 py-3 rounded-full font-semibold uppercase text-sm hover:opacity-90 transition-all hover:scale-105"
            >
              Book a Class
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-[#d9fb06] hover:text-[#d9fb06]/80 transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pt-4 pb-2 space-y-3 border-t border-[#3f4816] mt-4">
            {navLinks.map((link) => (
              link.disabled ? (
                <span
                  key={link.path}
                  className="block py-2 text-base font-medium text-[#888680] cursor-not-allowed opacity-50"
                >
                  {link.name}
                </span>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={`block py-2 text-base font-medium transition-colors ${
                    isActive(link.path) ? 'text-[#d9fb06]' : 'text-[#dfddd6] hover:text-[#d9fb06]'
                  }`}
                >
                  {link.name}
                </Link>
              )
            ))}
            <Link
              to="/book"
              onClick={() => setIsOpen(false)}
              className="block w-full text-center bg-[#d9fb06] text-[#1a1c1b] px-6 py-3 rounded-full font-semibold uppercase text-sm hover:opacity-90 transition-all mt-4"
            >
              Book a Class
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
